<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar">
    <!--begin: Search -->
    <!--end: Search -->

    <!--begin: Notifications -->
    <NotificationDropdown />
    <!--end: Notifications -->

    <!--begin: Tickets -->
    <div class="topbar-item">
      <router-link :to="{ name: ticketsRoute }" title="پشتیبانی" class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1">
        <span class="svg-icon svg-icon-xl svg-icon-primary">
          <inline-svg src="/media/svg/icons/Devices/Headphones.svg" />
        </span>
        <span v-show="ticketUnread" class="font-weight-bolder text-success py-1 font-size-lg">
          {{ ticketUnread }}
        </span>
      </router-link>
    </div>
    <!--end: Tickets -->

    <!--begin: Prices -->
    <div v-if="showFinancialPart" class="topbar-item">
      <router-link :to="{ name: 'calculator-index' }" title="محاسبه قیمت"
        class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1">
        <span class="svg-icon svg-icon-xl svg-icon-primary">
          <inline-svg src="/media/svg/icons/Shopping/Calculator.svg" />
        </span>
      </router-link>
    </div>
    <!--end: Prices -->

    <!--begin: Quick Actions -->
    <b-dropdown v-if="showFinancialPart" size="sm" variant="link" toggle-class="topbar-item text-decoration-none"
      no-caret right no-flip>
      <template v-slot:button-content data-id="shivaaa">
        <div class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1" title="کیف پول" @click="updateWallet()">
          <span class="svg-icon svg-icon-xl svg-icon-primary">
            <inline-svg src="/media/svg/icons/Shopping/Wallet.svg" />
          </span>
        </div>
      </template>
      <b-dropdown-text tag="div" class="min-w-md-350px">
        <DropdownQuickAction :render="counter"></DropdownQuickAction>
      </b-dropdown-text>
    </b-dropdown>
    <!--end: Quick Actions -->

    <!--begin: My Cart -->
    <!--end: My Cart -->

    <!--begin: Quick panel toggle -->
    <!--end: Quick panel toggle -->

    <!--begin: Language bar -->
    <!--end: Language bar -->

    <!--begin: User Bar -->
    <KTQuickUser></KTQuickUser>
    <!--end: User Bar -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;

    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;

    .b-dropdown-text {
      padding: 0;
    }
  }
}


</style>

<script>
import DropdownQuickAction from "@/view/layout/extras/dropdown/DropdownQuickAction.vue";
import KTQuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import i18nService from "@/core/services/i18n.service.js";
import { GET_PRICES } from "@/core/services/store/prices.module";
import { VERIFY_USER } from "@/core/services/store/profile.module";
import NotificationDropdown from "@/view/layout/extras/dropdown/NotificationDropdown.vue";
import { mapGetters } from "vuex";
export default {
  name: "KTTopbar",
  data() {
    return {
      languageFlag: "",
      languages: i18nService.languages,
      counter: +new Date(),
      hovered: false,
    };
  },
  mounted() {
    this.$store.dispatch(GET_PRICES);
  },

  components: {
    DropdownQuickAction,
    KTQuickUser,
    NotificationDropdown
  },
  methods: {
    updateWallet() {
      this.$store.dispatch(VERIFY_USER).catch(e => void e);
    },
    onLanguageChanged() {
      this.languageFlag = this.languages.find(val => {
        return val.lang === i18nService.getActiveLanguage();
      }).flag;
    },



    formatDate(date) {
      return new Date(date).toLocaleString("fa-IR", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    },


  },
  computed: {
    ...mapGetters("notification", [
      "notifications",
      "unreadNotificationCount"
    ]),
    ...mapGetters([
      "tickets"]),

    ticketUnread() {
      const ticketsAnswered = this.tickets
        .map(ti => ti.status)
        .filter(st => st === 2);
      return ticketsAnswered.length;
    },
    ticketsRoute() {
      if (this.isOperator) {
        return "admin-tickets-index";
      }
      if (this.isCompanyOwner) {
        return "admin-tickets-index";
      }
      return "tickets-index";
    },
    getLanguageFlag() {
      return this.onLanguageChanged();
    },
  }
};
</script>
